import React from 'react';

const Pagamentos = () => {
  const pagamentos = [
    {
      data: '01/07/2025',
      cliente: 'João Silva',
      valor: 'R$ 99,00',
      status: 'Pago',
    },
    {
      data: '30/06/2025',
      cliente: 'Maria Souza',
      valor: 'R$ 99,00',
      status: 'Pendente',
    },
  ];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Histórico de Pagamentos</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white rounded shadow">
          <thead>
            <tr>
              <th className="text-left p-2">Data</th>
              <th className="text-left p-2">Cliente</th>
              <th className="text-left p-2">Valor</th>
              <th className="text-left p-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {pagamentos.map((p, idx) => (
              <tr key={idx} className="border-t">
                <td className="p-2">{p.data}</td>
                <td className="p-2">{p.cliente}</td>
                <td className="p-2">{p.valor}</td>
                <td className="p-2">
                  <span
                    className={`px-2 py-1 rounded text-xs ${
                      p.status === 'Pago'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-yellow-100 text-yellow-800'
                    }`}
                  >
                    {p.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Pagamentos;
